export const LOGIN_PATH = "/";
export const FORGOT_PASSWORD_PATH = "/forgot-password";
export const RESET_PASSWORD_PATH = "/reset-password";
export const SET_PASSWORD_PATH = "/set-password";

// Account
export const ACCOUNT_PATH = "/account";

// Text Pages
export const TEXT_PAGES_PATH = "/content-management/text-pages";
export const TEXT_PAGES_ADD_PATH =
  "/content-management/text-pages/add-or-update";
export const TEXT_PAGES_UPDATE_PATH =
  "/content-management/text-pages/add-or-update/:key";

// Explore Banners
export const EXPLORE_BANNERS_PATH = "/content-management/explore-banners";
export const EXPLORE_BANNERS_ADD_PATH =
  "/content-management/explore-banners/add-or-update";
export const EXPLORE_BANNERS_UPDATE_PATH =
  "/content-management/explore-banners/add-or-update/:id";

// Deal Banners
export const DEAL_BANNERS_PATH = "/promotions/deal-banners";
export const DEAL_BANNERS_ADD_PATH = "/promotions/deal-banners/add-or-update";
export const DEAL_BANNERS_UPDATE_PATH =
  "/promotions/deal-banners/add-or-update/:id";

// Deals
export const DEALS_PATH = "/promotions/deals";
export const DEALS_ADD_PATH = "/promotions/deals/add-or-update";
export const DEALS_UPDATE_PATH = "/promotions/deals/add-or-update/:id";
export const EVENT_TICKETS_PATH = "/promotions/deals/tickets";
export const DEAL_VOUCHERS_PATH = "/promotions/deals/vouchers";
export const DEAL_REDEMPTIONS_PATH = "/promotions/deals/redemptions";

// Dynamic Campaigns
export const DYNAMIC_CAMPAIGNS_PATH = "/promotions/dynamic-campaigns";
export const DYNAMIC_CAMPAIGNS_ADD_PATH =
  "/promotions/dynamic-campaigns/add-or-update";
export const DYNAMIC_CAMPAIGNS_UPDATE_PATH =
  "/promotions/dynamic-campaigns/add-or-update/:id";
export const PER_TRANSACTION_PARTICIPATION_PATH =
  "/promotions/dynamic-campaigns/per-transaction";
export const GOAL_REACHED_PARTICIPATION_PATH =
  "/promotions/dynamic-campaigns/goal-reached";
export const STREAK_PARTICIPATION_PATH = "/promotions/dynamic-campaigns/streak";

// Promo Codes
export const PROMO_CODES_PATH = "/promotions/promo-codes";
export const PROMO_CODES_ADD_PATH = "/promotions/promo-codes/add-or-update";
export const PROMO_CODES_ANALYTICS_PATH = "/promotions/promo-codes/analytics";
export const PROMO_CODES_UPDATE_PATH =
  "/promotions/promo-codes/add-or-update/:id";

// Static Campaigns
export const REFERRAL_PATH = "/promotions/static-campaigns/referral";
export const REFERRAL_ADD_PATH =
  "/promotions/static-campaigns/referral/add-or-update";
export const LOYALTY_ANNIVERSARY_PATH =
  "/promotions/static-campaigns/loyalty-anniversary";
export const LOYALTY_ANNIVERSARY_ADD_PATH =
  "/promotions/static-campaigns/loyalty-anniversary/add-or-update";
export const WELCOME_BONUS_PATH = "/promotions/static-campaigns/welcome-bonus";
export const WELCOME_BONUS_ADD_PATH =
  "/promotions/static-campaigns/welcome-bonus/add-or-update";
export const BIRTHDAY_REWARD_PATH =
  "/promotions/static-campaigns/birthday-reward";
export const BIRTHDAY_REWARD_ADD_PATH =
  "/promotions/static-campaigns/birthday-reward/add-or-update";

// Referrals
export const REFERRALS_PATH = "/campaigns/referrals";
export const REFERRALS_ADD_PATH = "/campaigns/referrals/add-or-update";

// Tiers
export const TIERS_PATH = "/tierManagement/tiers";
export const TIERS_ADD_PATH = "/tierManagement/tiers/add-or-update";

// System Users
export const SYSTEM_USERS_PATH = "/system-users/system-users";
export const SYSTEM_USERS_ADD_PATH = "/system-users/system-users/add-or-update";
export const SYSTEM_USERS_UPDATE_PATH =
  "/system-users/system-users/add-or-update/:id";

// Audit Logs
export const AUDIT_LOGS_PATH = "/system-users/audit-logs";
export const AUDIT_LOG_DETAILS_PATH = "/system-users/audit-logs/detail";

// AppLication Update
export const APPLICATION_UPDATE_ANDROID_PATH =
  "/config/application-update/android/add-or-update";
export const APPLICATION_UPDATE_IOS_PATH =
  "/config/application-update/ios/add-or-update";

// Customers
export const CUSTOMERS_PATH = "/customer-management/customers";
export const CUSTOMER_DETAIL_PATH = "/customer-management/customers/detail";
export const CUSTOMER_DETAIL_ID_PATH =
  "/customer-management/customers/detail/:id";
export const CUSTOMER_FEEDBACKS_PATH = "/customer-management/feedbacks";

// Customer Groups
export const CUSTOMER_GROUPS_PATH = "/customer-management/customer-groups";
export const CUSTOMER_GROUPS_ADD_PATH =
  "/customer-management/customer-groups/add-or-update";
export const CUSTOMER_GROUPS_UPDATE_PATH =
  "/customer-management/customer-groups/add-or-update/:id";

// finance
export const TRANSACTIONS_PATH = "/finance/transactions";
export const TRANSACTIONS_DETAIL_PATH = "/finance/transactions/detail";
export const PURCHASES_PATH = "/finance/purchases";
// export const PURCHASES_DETAIL_PATH = "/finance/purchases/detail";

// Venues
export const VENUES_PATH = "/venue-management/venues";
export const VENUES_ADD_PATH = "/venue-management/venues/add-or-update";
export const VENUES_UPDATE_PATH = "/venue-management/venues/add-or-update/:id";

// Amenities
export const AMENITIES_PATH = "/venue-management/amenities";
export const AMENITIES_ADD_PATH = "/venue-management/amenities/add-or-update";
export const AMENITIES_UPDATE_PATH =
  "/venue-management/amenities/add-or-update/:id";

// Venue Categories
export const VENUE_CATEGORIES_PATH = "/venue-management/venue-categories";
export const VENUE_CATEGORIES_ADD_PATH =
  "/venue-management/venue-categories/add-or-update";
export const VENUE_CATEGORIES_UPDATE_PATH =
  "/venue-management/venue-categories/add-or-update/:id";

// Notifications
export const NOTIFICATION_TEMPLATES_PATH =
  "/notifications/notification-templates";
export const NOTIFICATION_TEMPLATES_ADD_PATH =
  "/notifications/notification-templates/add-or-update";
export const NOTIFICATION_TEMPLATES_UPDATE_PATH =
  "/notifications/notification-templates/add-or-update/:id";

// Operations Hub
export const OPERATORS_PATH = "/operations-hub/operators";
export const OPERATOR_ADD_PATH = "/operations-hub/operators/add-or-update";
export const OPERATOR_UPDATE_PATH =
  "/operations-hub/operators/add-or-update/:id";
export const MANAGERS_PATH = "/operations-hub/managers";
export const MANAGER_ADD_PATH = "/operations-hub/managers/add-or-update";
export const MANAGER_UPDATE_PATH = "/operations-hub/managers/add-or-update/:id";

// Club Iveria
export const CASINO_CONFIG_PATH = "/club-iveria/casino-config";
